/**
 * InLineText component module.
 * @module shared/components/InLineText
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled, {withTheme} from 'styled-components/macro';

const _BodyText = styled.span`
  ${(props) => props.margin ? `margin: ${props.margin}` : ''};
  ${(props) => props.font ? `font-family: ${props.theme[props.font].name}` : ''};
  ${(props) => props.fontSize ? `font-size: ${props.fontSize}` : ''};
  ${(props) => props.color ? `color: ${props.color}` : ''};
  ${(props) => props.opacity ? `opacity: ${props.opacity}` : ''};
  ${(props) => props.bold ? 'font-weight: bold;' : ''};
  ${(props) => props.underline ? 'text-decoration: underline;' : ''};
  ${(props) => props.italic ? 'font-style: italic;' : ''};
  ${(props) => props.verticalAlign ? 'display: inline-flex;flex-direction: row;align-items: center;margin-top: 4px;' : ''};
`;

const InLineText = (props) => {
  const opts = {...props};
  delete opts.children;
  return <_BodyText {...opts}>{props.children}</_BodyText>;
};

export default withTheme(InLineText);

InLineText.propTypes = {
  /**
   * CSS margin
   */
  margin: PropTypes.string,
  /**
   * Font being one of the theme's font such as 'bodyText' should always be based on theme.
   */
  font: PropTypes.string,
  /**
   * CSS Font Size
   */
  fontSize: PropTypes.string,
  /**
   * CSS Opacity
   */
  opacity: PropTypes.number,
  /**
   * The Copy/body of the InLineText
   */
  children: PropTypes.node.isRequired,
  /**
   * The color of the text. Based on theme if not specified.
   */
  color: PropTypes.string,
  bold: PropTypes.bool,
  italic: PropTypes.bool,
  underline: PropTypes.bool,
  verticalAlign: PropTypes.bool,
};
